<template>
	<section class="marketing-section bg-color-white">
		<div class="container">
			<h2 class="heading-1 mb-300-md mb-100-smo text-align-center-md">Assets</h2>
			<FundDetailsAssetsOverview
				:asset-elements="props.assets"
				:strategy-allocations="strategyAllocations"
				:asset-type-allocations="assetTypeAllocations"
				:center-asset-allocations="true"
			/>
			<div v-if="showLiterature" class="mt-300-md mt-200-smo">
				<h3 class="heading-5">Literature</h3>
				<LiteratureSection
					:literature-list="literatureItems"
					:disclaimer="literatureDisclaimer"
					disclaimer-classes="body-medium col-8-md text-color-content-secondary mt-50 mb-100-md mb-200-smo"
				/>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { Fund, FundAssetAllocation, FundLiterature } from 'types/funds';
import { Asset } from 'types/assets';
import { computed } from 'vue';
import FundDetailsAssetsOverview from '@components/offering-details/fund-details/fund-details-assets-overview.vue';
import LiteratureSection from '@components/offering-details/literature-section.vue';
import { SanityRichTextBlock } from 'types/sanity';

interface Props {
	fund: Fund | null;
	assets: Array<Asset>;
}

const props = defineProps<Props>();

const assetTypeAllocations = computed((): Array<FundAssetAllocation> => {
	return props.fund?.assetTypeAllocations ?? [];
});

const strategyAllocations = computed((): Array<FundAssetAllocation> => {
	return props.fund?.strategyAllocations ?? [];
});

const literatureItems = computed((): Array<FundLiterature> => {
	return props.fund?.literature ?? [];
});

const literatureDisclaimer = computed((): Array<SanityRichTextBlock> => {
	return props.fund?.literatureDisclaimer ?? [];
});

const showLiterature = computed((): boolean => {
	return literatureItems.value.length > 0;
});
</script>
